import { useEffect, useState } from "react";
import { useApi } from "../../hooks/useApi";

// Genera color estable basado en el nombre
function hashColor(str) {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    const hue = Math.abs(hash % 360);
    return `hsl(${hue}, 70%, 65%)`;
}

function ChainList({
    userEmail,
    selectedChain,
    setSelectedChain,
    isLocked,
    tileMode = false
}) {
    const { get } = useApi();
    const [chains, setChains] = useState([]);

    useEffect(() => {
        const fetchChains = async () => {
            try {
                const data = await get("chainsByUserEmail", {
                    urlParams: { id: userEmail },
                });
                setChains(data);
            } catch {
                setChains([]);
            }
        };

        if (userEmail) fetchChains();
    }, [userEmail, get]);

    // --- MODO SELECT (ORIGINAL)
    if (!tileMode) {
        return (
            <select
                name="chainId"
                value={selectedChain}
                onChange={(e) => setSelectedChain(e.target.value)}
                disabled={isLocked}
                className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-[#233F93] focus:outline-none shadow-sm"
            >
                <option value="">
                    {chains.length ? "Seleccione..." : "Sin cadenas disponibles"}
                </option>
                {chains.map((c) => (
                    <option key={c.chain} value={c.chain}>
                        {c.chain}
                    </option>
                ))}
            </select>
        );
    }

    // --- MODO TILES
    return (
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-5">
            {chains.map((c) => {
                const bgColor = c.color || hashColor(c.chain);
                const isSelected = selectedChain === c.chain;

                return (
                    <button
                        key={c.chain}
                        disabled={isLocked}
                        onClick={() => setSelectedChain(c.chain)}
                        className={`
                        relative overflow-hidden
                        flex items-center justify-center
                        h-20 w-full
                        rounded-2xl shadow
                        font-bold text-white text-lg
                        transition-all duration-200
                        ${isSelected ? "ring-4 ring-blue-700 scale-[1.04]" : "hover:scale-[1.03]"}
                    `}
                        style={{ backgroundColor: bgColor }}
                    >
                        <span className="drop-shadow">{c.chain}</span>

                        {isSelected && (
                            <div className="absolute inset-0 bg-black/10 pointer-events-none rounded-2xl" />
                        )}
                    </button>
                );
            })}
        </div>
    );
}

export default ChainList;